/*-
 * #%L
 * Aires Éducatives
 * %%
 * Copyright (C) 2020 - 2023 OFB
 * %%
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 * #L%
 */

import { format } from "date-fns"
import { fr } from "date-fns/locale"

export const DATE_PATTERN_FR = "dd/MM/yyyy"
export const DATE_TIME_PATTERN_FR = "dd/MM/yyyy HH:mm"

export default class DateUtils {
  static formatDateFromPattern(date: Date, pattern: string): string {
    return date && pattern ? format(date, pattern, { locale: fr }) : ""
  }

  static formatDate(date: Date): string {
    return this.formatDateFromPattern(date, DATE_PATTERN_FR)
  }

  static formatDateTime(date: Date): string {
    return this.formatDateFromPattern(date, DATE_TIME_PATTERN_FR)
  }
}
